export default {
  methods: node => {
    /* eslint-disable no-underscore-dangle */
    switch (node.__typename) {
      case 'CashPaymentMethod':
        return 'Cash';
      case 'CheckPaymentMethod':
        return 'Check';
      case 'SquarePaymentMethod':
        return 'Credit Card';
      case 'CustomPaymentMethod':
        return node.label;
      default:
        return null;
    }
  },
  payments: node => {
    /* eslint-disable no-underscore-dangle */
    switch (node.__typename) {
      case 'CashPayment':
        return 'Cash';
      case 'CheckPayment':
        return 'Check';
      case 'SquarePayment':
        return 'Credit Card';
      case 'CustomPayment':
        return node.label;
      default:
        return null;
    }
  },
  getPaymentMethod: (viewer, paymentMethod) => {
    const methods = viewer.payment_methods.edges.filter(
      /* eslint-disable no-underscore-dangle */
      method => method.node.__typename === paymentMethod
    );
    return methods[0] && methods[0].node ? methods[0].node : null;
  },
  refundedCents: payment =>
    payment.refunds.edges.reduce(
      (total, { node: refund }) => total + refund.amount_cents,
      0
    )
};



// WEBPACK FOOTER //
// ./webpack/lib/utils/payments.js